module.exports = __webpack_public_path__ + "fonts/ConfigCondensed-BlackItalic.0a16ff2a.otf";